import React from 'react'

const Slide = ({ children }) => <div className="slide">{children}</div>

export default Slide
